module.exports = __webpack_public_path__ + "static/media/token-logo.9ac96b27.png";